import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, AlertCircleIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
const terms = [{
  title: '1. Scope of services',
  content: 'We will provide brand identity services as outlined in the agreed proposal or statement of work. This may include but is not limited to brand strategy visual identity logo design typography colour palette and brand guidelines. Any work not expressly included is considered out of scope and may require a separate agreement or additional fees.'
}, {
  title: '2. Project timeline and client responsibilities',
  content: 'Project timelines are dependent on timely feedback content and approvals from you. Delays in providing required materials or feedback may impact delivery dates and we are not responsible for delays caused by the client.'
}, {
  title: '3. Fees and payment',
  content: 'All fees are as set out in the agreed proposal. Unless otherwise stated a deposit is required before work begins with the balance payable upon project completion. Invoices must be paid within the stated payment period. Late payments may result in work being paused until payment is received.'
}, {
  title: '4. Revisions',
  content: 'The project includes a reasonable number of revision rounds as outlined in the proposal. Additional revisions or changes outside the agreed scope may be charged at our standard rates.'
}, {
  title: '5. Intellectual property',
  content: 'Upon full payment you will receive ownership of the final approved brand identity deliverables. We retain ownership of all concepts unused drafts and working files unless otherwise agreed in writing. We reserve the right to showcase the work in our portfolio website and marketing materials unless confidentiality has been agreed in advance.'
}, {
  title: '6. Third party materials',
  content: 'Any third party assets such as fonts stock imagery or software licences are subject to their own terms. Unless explicitly stated responsibility for ongoing licences rests with you.'
}, {
  title: '7. Confidentiality',
  content: 'Both parties agree to keep confidential any non public information shared during the project unless disclosure is required by law or agreed in writing.'
}, {
  title: '8. Limitation of liability',
  content: 'We will carry out services with reasonable skill and care. Our liability is limited to the total fees paid for the project. We are not liable for indirect losses loss of profit or business interruption.'
}, {
  title: '9. Termination',
  content: 'Either party may terminate the project with written notice. Fees for work completed up to the termination date remain payable. Deposits are non refundable once work has commenced.'
}, {
  title: '10. Governing law',
  content: 'These Terms and Conditions are governed by and interpreted in accordance with the laws of England and Wales and the courts of England and Wales shall have exclusive jurisdiction.'
}];
export function TermsAccordion() {
  const [openIndex, setOpenIndex] = useState<number[]>([]);
  const toggle = (i: number) => setOpenIndex(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]);
  return <section id="terms" className="py-20 md:py-32 px-5 md:px-10 border-b border-rule/60" data-id="element-321">
      <div className="max-w-6xl mx-auto" data-id="element-322">
        <ScrollReveal data-id="element-323">
          <div className="mb-12 md:mb-16 max-w-3xl" data-id="element-324">
            <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6 font-medium" data-id="element-325">
              — Important Note &amp; Terms
            </p>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink font-light mb-8" data-id="element-326">
              Just so we're aligned.
            </h2>
          </div>
        </ScrollReveal>

        {/* Important note */}
        <ScrollReveal delay={0.05} data-id="element-327">
          <div className="mb-12 md:mb-16 p-6 md:p-10 bg-paper border-l-2 border-gold" data-id="element-328">
            <div className="flex gap-4 mb-4" data-id="element-329">
              <AlertCircleIcon className="w-5 h-5 text-gold flex-shrink-0 mt-1" data-id="element-330" />
              <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute font-medium" data-id="element-331">
                Important Note
              </p>
            </div>
            <p className="text-base md:text-lg text-ink-soft leading-relaxed font-light mb-4" data-id="element-332">
              This proposal is based on the current understanding of the project
              following our clarity call. Final scope, timings, and deliverables
              may be refined slightly depending on feedback, approvals, and any
              additional requirements that emerge during the process.
            </p>
            <p className="text-base md:text-lg text-ink leading-relaxed font-serif italic" data-id="element-333">
              The reduced ecommerce website rate is only valid for 3 days from
              the proposal date and applies only if approved within that
              timeframe.
            </p>
          </div>
        </ScrollReveal>

        {/* Terms accordion */}
        <ScrollReveal delay={0.1} data-id="element-334">
          <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute mb-6 font-medium" data-id="element-335">
            Terms &amp; Conditions
          </p>
          <div className="border-t border-ink/80" data-id="element-336">
            {terms.map((term, index) => {
            const open = openIndex.includes(index);
            return <div key={index} className="border-b border-rule" data-id="element-337">
                  <button onClick={() => toggle(index)} className="w-full flex items-center justify-between py-5 md:py-6 text-left group" data-id="element-338">
                    <span className="font-serif text-base md:text-lg text-ink font-normal pr-4" data-id="element-339">
                      {term.title}
                    </span>
                    <PlusIcon className={`w-5 h-5 text-ink-mute transition-transform duration-300 flex-shrink-0 ${open ? 'rotate-45 text-gold' : ''}`} data-id="element-340" />
                  </button>
                  <AnimatePresence data-id="element-341">
                    {open && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-342">
                        <p className="pb-6 md:pb-8 pr-12 text-sm md:text-base text-ink-soft font-light leading-relaxed" data-id="element-343">
                          {term.content}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </ScrollReveal>
      </div>
    </section>;
}